<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">{{ 'followUps.modal.listTitle' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="close()"></i>
  </div>
  <div class="modal-body">
    <app-data-table [configuration]="dataTableConfiguration"></app-data-table>
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      class="btn btn-clear"
      data-cy="fu-list-dialog-close-btn"
      (click)="close()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>

<ng-template #statusTemplate let-followUp="row">
  <div class="pe-2">
    @switch (followUp.lastStatus) {
      @case (FollowUpStatus.Generated) {
        <div class="text-blue">
          {{ 'followUps.list.status.' + followUp.lastStatus | translate }}
        </div>
      }
      @case (FollowUpStatus.InProgress) {
        <div class="text-warning">
          {{ 'followUps.list.status.' + followUp.lastStatus | translate }}
        </div>
      }
      @default {
        <div class="text-success">
          {{ 'followUps.list.status.' + followUp.lastStatus | translate }}
        </div>
      }
    }
  </div>
</ng-template>
